import useAllCoinHooks, { CoinType } from '@/hooks/useAllCoinHooks'
import { cnTw } from '@/utils'
import { Button, Input, Modal, ModalBody, ModalContent, ModalHeader, Spinner, Tooltip, useDisclosure } from '@nextui-org/react'
import { useEffect, useState } from 'react'
import { IType, valueInit } from './Swap'
import { useTranslation } from 'react-i18next'
import { ReactComponent as SELECT } from '@/assets/svg/select.svg'
import { ReactComponent as SELECT_NO } from '@/assets/svg/select-no.svg'

/**
 * @param isSend 是否发送
 * @param color 颜色
 * @param selectInfo 选择的币种信息
 * @param otherCoin 另一个币种
 * @param otherCode 另一个币种代码
 * @param onSelect 选择币种
 * @param value 数量
 * @param onValueChange 数量变化
 * @param type 类型
 * @param otherRate 另一个币种汇率
 * @param isPriceLoading 汇率加载中
 * @param isOpacity 是否不能兑换
 */
interface Props {
	isSend?: boolean
	color: string
	selectInfo: CoinType | undefined
	otherCoin: string | undefined
	otherCode: string
	onSelect: (coin: CoinType) => void
	value: string
	onValueChange: (value: string) => void
	type: IType
	otherRate?: number | undefined
	isPriceLoading: boolean
	isOpacity?: boolean
	isOpacityText?: string
	max?: number
	min?: number
}

export default function HomeSendReceiveCard({
	isSend = false,
	color,
	onSelect,
	selectInfo,
	otherCoin,
	otherRate,
	isOpacity = false,
	min = 0,
	max = 0,
	...props
}: Props) {
	const { t } = useTranslation()
	const { list } = useAllCoinHooks().data
	const args = useAllCoinHooks()

	const { isOpen, onOpen, onOpenChange } = useDisclosure()

	const [searchValue, setSearchValue] = useState('')

	useEffect(() => {
		if (!isOpen) setSearchValue('')
	}, [isOpen])

	useEffect(() => {
		console.log('otherCoin && otherRate', otherCoin, otherRate)
	}, [selectInfo, otherCoin, otherRate])

	return (
		<>
			<div className="tail-send-receive-card flex flex-col gap-4">
				<div className="flex items-center justify-between">
					<Button
						isLoading={args.isLoading}
						onClick={() => onOpen()}
						startContent={
							!args.isLoading &&
							selectInfo?.logo && <img src={selectInfo?.logo || ''} alt="" className="flex h-[2.625rem] w-[2.625rem] shrink-0" />
						}
						className="h-11 shrink-0 rounded-none rounded-r-md bg-transparent px-0"
					>
						<div className="rounded px-0.5 text-[0.8125rem] leading-3 text-white">
							<div className="flex items-center gap-1">
								<span>{selectInfo?.network}</span>
								<div className="ml-0.5 shrink-0">
									<svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path
											d="M0.900879 1.61746L3.36424 4.08082L5.8276 1.61746"
											stroke="white"
											stroke-width="1.64224"
											stroke-linecap="round"
										/>
									</svg>
								</div>
							</div>
							{otherCoin && otherRate && (
								<div className="text-[0.625rem] text-[#A6A6A6]">
									1{selectInfo?.coin} = {otherRate}
									{otherCoin}
								</div>
							)}
						</div>
					</Button>
					<div
						className="flex h-[1.375rem] items-center justify-center rounded-full px-2 text-xs text-white"
						// style={{ background: color, color: color === '#ffffff' ? 'black' : 'white' }}
						style={{
							background: isSend ? '#192FB9' : '#5D19B4',
						}}
					>
						{isSend ? t('swap.card.send') : t('swap.card.receive')}
					</div>
				</div>
				<div
					className={cnTw(
						'flex h-11 items-center rounded-md',
						isSend ? (selectInfo?.send === '1' ? '' : 'opacity-50') : selectInfo?.recv === '1' ? '' : 'opacity-50',
						isOpacity ? '!opacity-50' : '',
					)}
				>
					<Tooltip
						classNames={{
							base: 'before:bg-[#ab0706]',
							content: 'bg-[#AB0706] shadow-none text-xs rounded-md px-1',
						}}
						content={
							<div className="flex items-center gap-1">
								<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path
										d="M9 1.125C4.65469 1.125 1.125 4.65469 1.125 9C1.125 13.3453 4.65469 16.875 9 16.875C13.3453 16.875 16.875 13.3453 16.875 9C16.875 4.65469 13.3453 1.125 9 1.125ZM9.5625 13.5H8.4375V12.375H9.5625V13.5ZM8.4375 11.25V4.5H9.5625V11.25H8.4375Z"
										fill="white"
									/>
								</svg>
								{props.isOpacityText}
							</div>
						}
						placement="bottom-start"
						showArrow
						isOpen={isOpacity}
					>
						<input
							type="text"
							style={{
								// color: color,
								color: 'white',
								fontSize: 24,
							}}
							disabled={!isSend ? true : false}
							value={props.value}
							onChange={e => {
								if (e.target.value === '' || e.target.value === '0') {
									props.onValueChange(e.target.value === '' ? '' : valueInit)
									return
								}
								;/^([0-9][0-9]*)+(\.[0-9]{0,6})?$/.test(e.target.value) && props.onValueChange(e.target.value)
							}}
							maxLength={20}
							className="h-full w-full rounded-l-md bg-transparent"
						/>
					</Tooltip>
					<div className="pr-3 text-white/30">{selectInfo?.code}</div>
				</div>
				<div className={cnTw('w-full', isSend && 'min-h-4')}>
					{props.isPriceLoading ? (
						<Spinner size="sm" color="white" />
					) : (
						<>
							{isSend && max !== 0 && min !== 0 && (
								<div className="flex items-center gap-2">
									<div className="rounded-md bg-[rgba(10,13,17,.6)] p-1 text-xs" style={{ color }}>
										<span className="mr-1 text-[0.625rem] !text-[#747474]">{t('swap.card.min')}</span>
										{min}
										{selectInfo?.coin}
									</div>
									<div className="rounded-md bg-[rgba(10,13,17,.6)] p-1 text-xs" style={{ color }}>
										<span className="mr-1 text-[0.625rem] !text-[#747474]">{t('swap.card.max')}</span>
										{max}
										{selectInfo?.coin}
									</div>
								</div>
							)}
						</>
					)}
				</div>
			</div>

			<Modal
				classNames={{
					base: '!m-0 w-full rounded-b-none rounded-t-xl border-transparent  sm:!mb-8 sm:w-96 sm:rounded-b-2xl',
				}}
				isOpen={isOpen}
				hideCloseButton
				scrollBehavior="inside"
				onOpenChange={onOpenChange}
			>
				<ModalContent>
					{onClose => (
						<>
							<ModalHeader className="flex items-center justify-between py-5">
								<Input
									radius="full"
									className="w-full"
									classNames={{
										inputWrapper: 'h-12',
									}}
									value={searchValue}
									onValueChange={setSearchValue}
									placeholder={t('swap.card.tips')}
									endContent={
										<svg
											className="shrink-0 cursor-pointer"
											width="18"
											height="18"
											viewBox="0 0 18 18"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M11.25 11.25L15.75 15.75M7.5 12.75C4.60051 12.75 2.25 10.3995 2.25 7.5C2.25 4.60051 4.60051 2.25 7.5 2.25C10.3995 2.25 12.75 4.60051 12.75 7.5C12.75 10.3995 10.3995 12.75 7.5 12.75Z"
												stroke="#0083FF"
												stroke-width="1.5"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
										</svg>
									}
								/>
							</ModalHeader>
							<ModalBody className="gap-4 pb-5">
								{list
									.filter(item => {
										if (searchValue === '') return true
										return item.coin.toLowerCase().startsWith(searchValue.toLowerCase())
									})
									.map(item => (
										<div
											key={item.code}
											className={cnTw(
												'flex h-12 w-full shrink-0 cursor-pointer items-center rounded-md px-2 hover:bg-default',
												isSend
													? item.send === '1'
														? ''
														: 'opacity-50 hover:bg-default/50'
													: item.recv === '1'
														? ''
														: 'opacity-50 hover:bg-default/50',
											)}
											onClick={() => {
												onSelect(item)
												// if (isSend) {
												// 	if (item.send === '0') props.onValueChange(valueInit)
												// } else {
												// 	if (item.recv === '0') props.onValueChange(valueInit)
												// }
												onClose()
											}}
										>
											<div className="flex w-full items-center justify-between">
												<div className="flex w-full items-center gap-2">
													<img src={item.logo} className="h-11 w-11" alt="" />
													<div className="flex flex-col items-start">
														<span
															className="text-sm text-white"
															style={{
																color: item.color,
															}}
														>
															{item.name} ({item.coin})
														</span>
														<span
															className="rounded px-0.5 text-[0.625rem] leading-3 text-[#18181b]"
															style={{
																background: item.color,
															}}
														>
															{item.network}
														</span>
													</div>
												</div>
												<div className="ml-2 flex flex-col items-center">
													{selectInfo?.code === item.code ? <SELECT /> : <SELECT_NO />}
												</div>
											</div>
										</div>
									))}
							</ModalBody>
						</>
					)}
				</ModalContent>
			</Modal>
		</>
	)
}
